<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toctit"><a id="page_vi"></a><a id="page_vii">CONTENTS</a></h1><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/Preface">Preface</a></p>
<p class="toc"><a href="#/xhtml/Intro">Introduction</a></p>
<p class="toc1"><a href="#/xhtml/Chapter1"><span class="small"><span class="lf">CHAPTER 1</span></span> Going beyond the Visible: Zhuangzi and the Upaniṣads</a></p>
<p class="toc1"><span href="#/xhtml/Chapter2" title="Link target outside of Sample"><span class="small"><span class="lf">CHAPTER 2</span></span> Appearance and Reality: Parmenides, Shankara, and Spinoza</span></p>
<p class="toc1"><span href="#/xhtml/Chapter3" title="Link target outside of Sample"><span class="small"><span class="lf">CHAPTER 3</span></span> Metaphysics and Morality: Zhu Xi, Plato, Aristotle, Plotinus</span></p>
<p class="toc1"><span href="#/xhtml/Chapter4" title="Link target outside of Sample"><span class="small"><span class="lf">CHAPTER 4</span></span> Indeterminacy and Moral Action: Laozi and Heraclitus</span></p>
<p class="toc1"><span href="#/xhtml/Chapter5" title="Link target outside of Sample"><span class="small"><span class="lf">CHAPTER 5</span></span> Virtue Is Knowledge: Socrates and Wang Yangming</span></p>
<p class="toc1"><span href="#/xhtml/Chapter6" title="Link target outside of Sample"><span class="small"><span class="lf">CHAPTER 6</span></span> The Ethical Mean: Confucius and Plato</span></p>
<p class="toc1"><span href="#/xhtml/Chapter7" title="Link target outside of Sample"><span class="small"><span class="lf">CHAPTER 7</span></span> Nonviolent Warriors: The Bhagavad Gita and Marcus Aurelius</span></p>
<p class="toc"><span href="#/xhtml/Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc2"><span href="#/xhtml/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc2"><span href="#/xhtml/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc2"><span href="#/xhtml/Index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?26b3e7a0